import React from "react";
import { Button } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useTranslation } from "react-i18next";

function LoginHelpButton({ merchantConfig, color, borderRadius }) {
  const { t } = useTranslation();
  const whatsappHelp = merchantConfig?.whatsapp_help;

  if (!whatsappHelp) {
    return null;
  }

  return (
    <Button
      href={whatsappHelp}
      target="_blank"
      rel="noopener noreferrer"
      variant="outlined"
      startIcon={<WhatsAppIcon />}
      style={{
        width: "100%",
        marginBottom: "20px",
        color: color || merchantConfig.primary_theme_color,
        borderColor: color || merchantConfig.primary_theme_color,
        borderRadius,
      }}
    >
      <span className="ui-label">{t("footer.needHelp")}</span>
    </Button>
  );
}

export default LoginHelpButton;
